import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { Accordion } from "ui/gluestack/accordion";
import { Text, View } from "react-native";
import { AssessmentAccordionPreview } from "app/features/reporting/organisms/AssessmentAccordionPreview";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { useMemo } from "react";
import { Link, LinkText } from "ui/gluestack/link";
import { formatTagText } from "ui/utils/nameUtil";
import { AssessmentEntryEditProvider } from "app/features/assessments/providers";

interface Props {
  tag?: FormEnums;
  data: SubmittedFormModel | SubmittedFormModel[];
  href?: string;
}
export function HandoverAssessmentHistory({ tag, data, href }: Props) {
  const normalizedData = useMemo(() => {
    if (!data) return [];
    return Array.isArray(data) ? data : [data];
  }, [data]);

  const filteredData = useMemo(() => {
    return tag
      ? normalizedData.filter((item) => item.form.tag === tag)
      : normalizedData;
  }, [normalizedData, tag]);

  return (
    <AssessmentEntryEditProvider>
      <View>
        <Accordion
          type="single"
          variant="filled"
          className="mb-10"
          defaultValue={
            filteredData?.[0] ? [`${filteredData[0].id}`] : undefined
          }
        >
          {filteredData?.map((item) => (
            <AssessmentAccordionPreview form={item} key={item.id} />
          ))}

          {!filteredData?.length && href ? (
            <Text>
              No reports listed. Click on
              <Link href={href}>
                <LinkText className="text-primary-500 underline text-sm mx-1 font-medium">
                  {`${tag ? `${formatTagText(tag)}` : ""}`}
                </LinkText>
              </Link>
              to create your first report.
            </Text>
          ) : null}
        </Accordion>
      </View>
    </AssessmentEntryEditProvider>
  );
}
